import { User } from '@racepointenergy/swc/scs/types'
import { MyAccountFormValues } from './types'

const emptyMyAccountValues: MyAccountFormValues = {
  firstName: '',
  lastName: '',
}

export const getMyAccountFormValues = (userObj: User): MyAccountFormValues => ({
  ...emptyMyAccountValues,
  firstName: userObj.firstName,
  lastName: userObj.lastName,
})
